"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Settings_styles_1 = require("./Settings.styles");
var Input = function (_a) {
    var label = _a.label, value = _a.value, prop = _a.prop, _b = _a.type, type = _b === void 0 ? "text" : _b, index = _a.index, onChange = _a.onChange;
    var styles = (0, Settings_styles_1.useStyles)();
    return (0, jsx_runtime_1.jsxs)("label", __assign({ className: styles.inputLabel }, { children: [label, (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("input", { type: type, value: value, onChange: function (e) { return onChange(index, prop, e.target.value); } })] }));
};
var Option = function (_a) {
    var keyValue = _a.keyValue, minWidth = _a.minWidth, maxWidth = _a.maxWidth, onChange = _a.onChange, onDelete = _a.onDelete, _b = _a.i18n, i18n = _b === void 0 ? {} : _b, index = _a.index;
    var styles = (0, Settings_styles_1.useStyles)();
    var _c = i18n.label_key, label_key = _c === void 0 ? "Description" : _c, _d = i18n.label_min_width, label_min_width = _d === void 0 ? "Min width" : _d, _e = i18n.label_max_width, label_max_width = _e === void 0 ? "Max width" : _e, _f = i18n.button_delete, button_delete = _f === void 0 ? "Delete" : _f;
    return (0, jsx_runtime_1.jsxs)("div", __assign({ className: styles.row }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: styles.inputsWrapper }, { children: [(0, jsx_runtime_1.jsx)(Input, { label: label_key, value: keyValue, prop: "key", index: index, onChange: onChange }), (0, jsx_runtime_1.jsx)(Input, { label: label_min_width, value: minWidth + '', prop: "minWidth", index: index, onChange: onChange, type: "number" }), (0, jsx_runtime_1.jsx)(Input, { label: label_max_width, value: maxWidth + '', prop: "maxWidth", index: index, onChange: onChange, type: "number" })] })), (0, jsx_runtime_1.jsx)("button", __assign({ className: styles.delete, onClick: function (e) {
                    e.preventDefault();
                    onDelete(index);
                } }, { children: button_delete }))] }));
};
var BreakpointsSettings = function (_a) {
    var options = _a.options, onChange = _a.onChange, _b = _a.i18n, i18n = _b === void 0 ? {} : _b;
    var styles = (0, Settings_styles_1.useStyles)();
    var _c = i18n.button_add, button_add = _c === void 0 ? "Add" : _c;
    return (0, jsx_runtime_1.jsxs)("div", __assign({ className: styles.root }, { children: [options.map(function (op, i) {
                return (0, jsx_runtime_1.jsx)(Option, { maxWidth: op.maxWidth, minWidth: op.minWidth, keyValue: op.key, i18n: i18n, index: i, onChange: function (modifyIndex, prop, value) {
                        onChange(options.map(function (val, index) {
                            if (index === modifyIndex) {
                                val[prop] = value;
                            }
                            return val;
                        }));
                    }, onDelete: function (deleteIndex) {
                        var newOptions = options.map(function (val, index) {
                            if (index === deleteIndex)
                                return null;
                            return val;
                        }).filter(function (el) { return el != null; });
                        onChange(newOptions);
                    } }, i);
            }), (0, jsx_runtime_1.jsx)("button", __assign({ className: styles.add, onClick: function (e) {
                    e.preventDefault();
                    onChange(__spreadArray(__spreadArray([], options, true), [
                        { key: "", minWidth: "", maxWidth: "" },
                    ], false));
                } }, { children: button_add }))] }));
};
exports.default = BreakpointsSettings;
